/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Checkbox, Chip, Grid, styled, Typography } from '@mui/material'
import DateRangeIcon from '@mui/icons-material/DateRange'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined'
import { type CaseloadHistoryObject } from 'core/types'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { useState } from 'react'
import ViewListIcon from '@mui/icons-material/ViewList'
import BookIcon from '@mui/icons-material/Book'
import S3Image from 'Components/S3Image'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
const StyledDiv = styled(Accordion)`
    max-width: 600px;
    border: 1px solid rgba(74, 143, 204, 1);
    padding:20px;
    border-radius:8px;
  .detailItem{
    svg {
      padding-right:10px;
    }
    display:flex;
    flex-direction:'row';
  }

  .MuiAccordionSummary-root .MuiAccordionSummary-content {
    display:flex;
    align-items:baseline;
  }
`
export interface CaseloadHistoryCardProps {
  data: CaseloadHistoryObject
}
export function CaseloadHistoryCard (props: CaseloadHistoryCardProps): JSX.Element {
  const [expanded, setExpanded] = useState(false)
  return <StyledDiv data-testid='managementSummaryBox'
    expanded={expanded}
    onChange={() => {
      setExpanded(!expanded)
    }}
  >
    <AccordionSummary
      aria-controls="panel2-content"
      id="panel2-header"
      expandIcon={expanded ? <RemoveIcon /> : <AddIcon />}
    >

      <Avatar sx={{ backgroundColor: 'rgba(74, 143, 204, 1)', marginRight: '10px' }}>{props.data.orgName[0]}</Avatar>
      <Box>
        <Typography sx={{ fontWeight: 'bold' }}>{props.data.orgName}</Typography>
        <Grid item className='detailItem'>
          {props.data.isdName}
        </Grid>
      </Box>
      <Chip className='statusIcon' label={props.data.endDate != null ? 'Closed' : 'Open'} icon={<FiberManualRecordIcon />}
        color='secondary' variant='outlined'
        sx={{ marginLeft: 'auto', height: '100%', alignSelf: 'center', backgroundColor: 'rgba(114, 42, 130, 0.1)', border: 'none' }}
      />
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ pl: '10px', display: 'block' }}>
        <Grid container columns={6} gap={0.5} sx={{ display: 'flex', flexDirection: 'column' }}>

          {props.data.startDate && (
            <Grid item className='detailItem'>
              <DateRangeIcon />
              {`Start Date - ${new Date(props.data.startDate).toLocaleDateString()}`}
            </Grid>
          )}
          {props.data.endDate && (
            <Grid item className='detailItem'>
              <EventAvailableIcon />
              {`Exit Date - ${new Date(props.data.endDate).toLocaleDateString()}`}
            </Grid>
          )}
          <Grid item className='detailItem'>
            <TaskAltIcon />
            {props.data.reason}
          </Grid>
          {(props.data.otherReason ?? '') !== '' && (
            <Grid item className='detailItem'>
              <Box> </Box>
              {props.data.otherReason}
            </Grid>)}
          <Grid item className='detailItem'>
            <GroupOutlinedIcon />
            <Box display={'flex'} flexDirection={'column'}>
              {props.data.caregiverNames.map(c => <Box>{c}</Box>)}
            </Box>
          </Grid>
          {props.data.careSummary !== '' && (
            <Grid item className='detailItem'>
              <SummarizeOutlinedIcon />
              <Box>{props.data.careSummary}</Box>
            </Grid>
          )}
          {props.data.providedEducations?.length > 0 && (

            <Grid item className='detailItem'>
              <BookIcon />
              <Box>
                {props.data.providedEducations?.map(
                  p => <Chip label={p} sx={{ mx: '5px' }}/>
                )}
              </Box>
            </Grid>
          )}
          {
            (props.data.needsMet != null || props.data.addressedMostImportant != null || (props.data.reasonNotMet != null && props.data.reasonNotMet !== '')) && (

              <Grid item className='detailItem'>
                <ViewListIcon />
                <Box>
                  {props.data.needsMet != null && (
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}><Typography fontWeight={'bold'} sx={{ mr: '10px' }}>Needs Met:</Typography><Typography>{props.data.needsMet ? 'Yes' : 'No'}</Typography></Box>
                  )}
                  {props.data.addressedMostImportant != null && (
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}><Typography fontWeight={'bold'} sx={{ mr: '10px' }}>Addressed most Important Matter:</Typography><Typography>{props.data.addressedMostImportant ? 'Yes' : 'No'}</Typography></Box>
                  )}
                  {props.data.reasonNotMet != null && props.data.reasonNotMet !== '' && (
                    <Box sx={{ display: 'flex', flexDirection: 'row' }}><Typography fontWeight={'bold'} sx={{ mr: '10px' }}>Reason their needs were not met:</Typography><Typography>{props.data.reasonNotMet}</Typography></Box>
                  )}
                </Box>
              </Grid>
            )}

        </Grid>

        <Box sx={{ display: 'flex', flexDirection: 'row', my: '10px', alignItems: 'center' }}>
          <Typography fontWeight={'bold'} >Services Added</Typography>
          <Box >
            <Checkbox checked={props.data.connectedToReferral} disabled />
          </Box>
          <Typography>Connected to Referral</Typography>
        </Box>
        {props.data.serviceLogs.length > 0 && (
          <Box sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}>
            {props.data.serviceLogs.map(s => <Box sx={{ p: '10px', display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'space-between', borderRadius: '10px', border: '1px solid #E7E7E7' }}>
              {s.s3Key == null && (
                <ContentPasteIcon />
              )}
              {s.s3Key != null && (
                <S3Image imageKey={s.s3Key ?? ''} style={{ height: '40px', width: '40px' }}/>
              )}
              <Typography sx={{ alignContent: 'center ' }}>
                {s.serviceName}
              </Typography>
              <Chip color='secondary' variant='outlined' sx={{ backgroundColor: 'rgba(114, 42, 130, 0.1)', border: 'none' }} label={s.status} icon={<FiberManualRecordIcon />} />
            </Box>)}
          </Box>
        )}
      </Box>

    </AccordionDetails>

  </StyledDiv>
}
